import { render, staticRenderFns } from "./archieveManager.vue?vue&type=template&id=2c166e22&"
import script from "./archieveManager.vue?vue&type=script&lang=js&"
export * from "./archieveManager.vue?vue&type=script&lang=js&"
import style0 from "./archieveManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports